// Header Scripts
// React app
const { render } = wp.element;
import NavDropdown from "../parts/NavDropdown";

const textContentsDefault = {
    title: 'Shipping Protection',
    path: '/protect',
    middle_info: {
        title: 'Protect',
        desc: 'Lost, stolen, or damaged packages create unhappy customers. Protect your customer’s orders every step of the way and provide instant issue resolution.'
    },
    right_info: {
        style: 'stats',
        stat1: '$12B',
        stat1_desc: 'Protected merchandise.',
        stat2: '95%',
        stat2_desc: 'Customer satisfaction.',
        stat3: '6%',
        stat3_desc: 'Less cart abandonment.',
        brand_img_path: '/assets/svg/merchantsLogosProtect.svg'
    }
};

const RFMNavDropdown = () => {
    return (
        <>
            <NavDropdown tabs={args.tabs} textContents={textContentsDefault} triggerIDs={args.triggerIDs} stylesheet_directory_uri={args.stylesheet_directory_uri} site_url={args.site_url}/>
        </>
    )
}

render(<RFMNavDropdown />, document.getElementById(`nav-dropdown-app`));

// If we navigate back to the page, close the mobile menu if open
// window.addEventListener("pageshow", () => {
//     const headerEl = document.querySelector('#header-refresh');
//     const mobileToggleCollapsed = headerEl.querySelector('#menu-toggle-collapsed-mobile');
//     const mobileToggleExpanded = headerEl.querySelector('#menu-toggle-expanded-mobile');

//     mobileToggleExpanded.parentElement.parentElement.querySelector('#menu-main-mobile').setAttribute('active', false);
//     mobileToggleCollapsed.parentElement.parentElement.querySelector('#menu-main-links-mobile').setAttribute('active', false);
//     mobileToggleCollapsed.setAttribute('active', true);
//     mobileToggleExpanded.setAttribute('active', false);
//     scrollHandler.enableScroll();
// });

// window.addEventListener('DOMContentLoaded', () => {
//     if ( document.querySelectorAll('#header-refresh').length > 0 ) {
//         const headerEl = document.querySelector('#header-refresh');

//         // Desktop Scripts
//         let activePanel,
//             activeButton;
//         let dropdownTriggerIDs = ['products-main', 'resources-main'];

//         document.querySelector('main').addEventListener('mouseover', () => {
//             if (activeButton && activePanel) {
//                 activeButton.setAttribute('active', false);
//                 activePanel.setAttribute('active', false);
//                 activePanel.parentElement.querySelector('#' + activeButton.id + '-section-container').setAttribute('active', false);
//             }
//         });

//         dropdownTriggerIDs.forEach(buttonID => {
//             headerEl.querySelector('#' + buttonID + '').addEventListener('mouseover', (event) => {
//                 if ( event.target.getAttribute('active') == "false" ) {
//                     if (activeButton && activePanel) {
//                         activeButton.setAttribute('active', false);
//                         activePanel.setAttribute('active', false);
//                         activePanel.parentElement.querySelector('#' + activeButton.id + '-section-container').setAttribute('active', false);
//                     }

//                     activeButton = event.target;
//                     activePanel = event.target.parentElement.querySelector('#' + activeButton.id + '-section');
//                     handleSidebarElChange(activePanel.querySelector('.c-nav__section--links-item').querySelector('.c-nav__section--left-link'));

//                     activeButton.setAttribute('active', true);
//                     activePanel.setAttribute('active', true);
//                     activePanel.parentElement.querySelector('#' + activeButton.id + '-section-container').setAttribute('active', true);
//                 }
//             });

//             headerEl.querySelector('#' + buttonID +'-mobile').addEventListener('click', (event) => {
//                 event.target.parentElement.querySelector('#' + buttonID + '-section-mobile').setAttribute('active', true);
//             });

//             headerEl.querySelector('#' + buttonID +'-back-mobile').addEventListener('click', () => {
//                 headerEl.querySelector('#' + buttonID +'-section-mobile').setAttribute('active', false);
//             });
//         });

//         let activeSidebarEl;

//         headerEl.querySelectorAll('.c-nav__section--links').forEach(linkHolder => {
//             [...linkHolder.children].forEach(sidebarLink => {
//                 sidebarLink.querySelector('.c-nav__section--left-link').addEventListener('mouseover', (event) => {
//                     handleSidebarElChange(event.target);
//                 }); 
//             });
//         });

//         function handleSidebarElChange(target) {
//             if ( target == activeSidebarEl ) {
//                 return;
//             }

//             let selectors = ['-header-content', '-header-small-content', '-links-wrapper' , '-subheader-content', '-learn-more', '-right-group'];

//             if ( activeSidebarEl ) {
//                 let oldSlug = activeSidebarEl.getAttribute('slug');
//                 activeSidebarEl.setAttribute('active', false);
//                 selectors.forEach(selector => {
//                     let selectedEl = headerEl.querySelector('#' + oldSlug + selector);
//                     if( selectedEl ) {
//                         selectedEl.setAttribute('active', false);
//                     }
//                 });
//             }

//             activeSidebarEl = target;

//             let slug = activeSidebarEl.getAttribute('slug');
//             activeSidebarEl.setAttribute('active', true);
//             selectors.forEach(selector => {
//                 let selectedEl = headerEl.querySelector('#' + slug + selector);
//                 if( selectedEl ) {
//                     selectedEl.setAttribute('active', true);
//                 }
//             });
//         }
        

//         // Mobile Scripts
//         let mobileToggleCollapsed = headerEl.querySelector('#menu-toggle-collapsed-mobile');
//         let mobileToggleExpanded = headerEl.querySelector('#menu-toggle-expanded-mobile');

//         mobileToggleCollapsed.addEventListener('click', () => {
//             mobileToggleCollapsed.parentElement.parentElement.querySelector('#menu-main-mobile').setAttribute('active', true);
//             mobileToggleCollapsed.parentElement.parentElement.querySelector('#menu-main-links-mobile').setAttribute('active', true);
//             mobileToggleExpanded.setAttribute('active', true);
//             mobileToggleCollapsed.setAttribute('active', false);
//             scrollHandler.disableScroll();
//         });

//         mobileToggleExpanded.addEventListener('click', () => {
//             mobileToggleExpanded.parentElement.parentElement.querySelector('#menu-main-mobile').setAttribute('active', false);
//             mobileToggleCollapsed.parentElement.parentElement.querySelector('#menu-main-links-mobile').setAttribute('active', false);
//             mobileToggleCollapsed.setAttribute('active', true);
//             mobileToggleExpanded.setAttribute('active', false);
//             scrollHandler.enableScroll();
//         });
//     }
// });